/** Returns whether a direct Enter or Space keypress should activate a job card. */
export const shouldActivateJobCard = (
  key: string,
  target: EventTarget | null,
  currentTarget: EventTarget | null
): boolean => target === currentTarget && (key === "Enter" || key === " ");
